/* eslint-disable no-useless-escape */

const Regex = {
  mailRegex: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
}

export default Regex;